angular.module('Directives')
    .directive('inputWarning',

        function($compile, $timeout){
            return {
                restrict: 'A',
                scope: {
                    name: '@',
                    message: '@',
                    fromForm: '='
                },
                link: inputWarningCtrl
            }

            function inputWarningCtrl($scope, $element, $attrs){
                var elem = $element.find('[required]');
                if(!elem.length)
                    elem = $element.find('[ng-required="true"]');
                $element.removeAttr('input-warning');
                if(elem.length){
                    elem.attr('name', $scope.name);
                    elem.attr('tooltip-append-to-body', 'true');
                    elem.attr('uib-tooltip', '{{' + $scope.message + '}}');
                    elem.attr('tooltip-class', 'tooltip-warning');
                    elem.attr('tooltip-placement', 'top');
                    elem.attr('tooltip-trigger', "'mouseenter'");
                    elem.attr('tooltip-enable', 'isInvalid()');
                    elem.addClass('input-warning-sync');
                    $element.attr('ng-class', "{'has-warning': " + " isInvalid()}");

                    $compile($element)($scope);
                    $scope.isInvalid = function() {
                        if($scope.fromForm[$scope.name]){
                            if($scope.fromForm[$scope.name].$invalid && $scope.fromForm[$scope.name].$touched){
                                return true;
                            }
                            else{
                                return false;
                            }
                        }
                        return false;
                    };
                }
            }
        });


// WEBPACK FOOTER //
// ./js/directives/inputWarning.js